export default "__VITE_ASSET__Cr4Tq9cg__"